module.exports = __webpack_public_path__ + "img/cama café.594562d1.svg";